import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import Global from '../../../store/global-selectors';
import * as GridConfigApi from '../../../store/grid-config.api';
import * as ShipmentsActions from '../../../store/shipments/shipments.actions';
import * as NavActions from '../../../store/shipments/nav/shipments.nav.actions';
import { ModalService } from 'ui-components/services/modal-service';
import { shipmentGridChangeColumns } from '../../../store/shipments/grid/shipments.grid.actions';
import { saveUserSettingGridConfig } from '../../../store/user/user.actions';
import { SaveShippingFilterviewModalContainer } from '../../../containers/save-shipping-filterview-modal-container';
import { DeleteShippingFilterviewModalContainer } from '../../../containers/delete-shipping-filterview-modal-container';
import { EditShippingFilterviewModalContainer } from '../../../containers/edit-shipping-filterview-modal-container';
import * as Actions from './shipments.filtering.actions';

export const updateGridWithNoFilters = (action$) => {
  return action$.pipe(
    ofType(
      Actions.SHIPMENTS_AUTOSWITCH_FILTERVIEW_DEFAULT,
      Actions.SHIPMENTS_DELETE_FILTERVIEW_SUCCESS,
      Actions.SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS,
      Actions.SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS,
    ),
    map(() => {
      return ShipmentsActions.requestGetShipments();
    }),
  );
};

export const switchActiveFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_SWITCH_FILTERVIEW),
    mergeMap(() => {
      return of(ShipmentsActions.requestGetShipments(), NavActions.clearSearchInput());
    }),
  );
};

export const getSavedFilterViewsRequest = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_GET_SAVED_FILTERVIEWS_REQUEST),
    mergeMap(() => {
      return GridConfigApi.getAllShipmentsGridConfigs().pipe(
        map((savedFilterViews) => {
          return Actions.getSavedFilterViewsSuccess(savedFilterViews);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const saveNewFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_SAVE_NEW_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveNewShipmentsGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveNewFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const saveExistingFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_SAVE_EXISTING_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      return GridConfigApi.saveExistingShipmentsGridConfig(action.filterView).pipe(
        map((filterView) => {
          return Actions.saveExistingFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const updateSavedViewGridConfig = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_SAVE_NEW_FILTERVIEW_SUCCESS, Actions.SHIPMENTS_SAVE_EXISTING_FILTERVIEW_SUCCESS),
    mergeMap((action) => {
      const state = getState();
      const { filterView } = action;
      const { gridViewId, filterViewId } = filterView;
      const gridConfig = Global.selectShipmentsGridCurrentViewGridConfigOrDefault(state, {
        statusViewId: gridViewId,
        activeFilterViewId: 'custom',
      });

      return of(
        shipmentGridChangeColumns(gridViewId, filterViewId, gridConfig),
        saveUserSettingGridConfig('shipments', gridViewId, filterViewId, gridConfig),
      );
    }),
  );
};

export const deleteFilterView = (action$) => {
  return action$.pipe(
    ofType(Actions.SHIPMENTS_DELETE_FILTERVIEW_REQUEST),
    mergeMap((action) => {
      const { filterView } = action;
      return GridConfigApi.deleteGridConfig(filterView).pipe(
        map(() => {
          return Actions.deleteFilterViewSuccess(filterView);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const launchSaveShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_SHIPPING_SAVE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: SaveShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchEditShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_SHIPPING_EDIT_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: EditShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const launchDeleteShippingViewModal = (action$) => {
  return action$.pipe(
    ofType(Actions.LAUNCH_SHIPPING_DELETE_VIEW_MODAL),
    mergeMap(() => {
      ModalService.launchModal({
        component: DeleteShippingFilterviewModalContainer,
      });
      return EMPTY;
    }),
  );
};
